import { Button, Grid, Paper, Typography } from "@mui/material"
import React from "react"
import { StyledPaper, TokenDetailsNav } from "../components"

interface MobileTabWrapperProps {
  tabs: JSX.Element[]
  tabsName: string[]
}

//Use this wrapper if the Mobile view design is a dual tab mode
const MobileTabWrapper = (props: MobileTabWrapperProps) => {
  const { tabs, tabsName } = props
  const [selectedTab, setSelectedTab] = React.useState(0)
  return (
    <Grid item container gap={2}>
      <TokenDetailsNav />
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '12.8rem',
        width: '100%',
        borderRadius: 1,
        padding: '0rem', //to show border
      }}>
        <Grid container flexDirection={'column'}>
          <Grid container item>
            {
              tabsName.map((label, index) => {
                const isSelected = selectedTab === index
                const isFirst = index === 0
                const isLast = index === tabs.length - 1
                const opacity = isSelected ? 0.24 : 0.12
                return (
                  <Grid item xs={6}>
                    <Button
                      onClick={() => setSelectedTab(index)}
                      sx={{
                        border: 0, borderRadius: isFirst ? '8px 0px 0px 0px' : isLast ? '0px 8px 0px 0px' : 0,
                        background: `rgb(255,255,255,${opacity})`,
                        width: '100%',
                        '&:hover': {
                          background: `rgb(255,255,255,${opacity})`,
                        }
                      }}>
                      <Typography variant="r" color='text.primary' key={label}>
                        {label}
                      </Typography>
                    </Button>
                  </Grid>
                )
              }
              )
            }
          </Grid>
          <Paper sx={{
            padding: '0.5rem 1rem',
            paddingBottom: '2rem',
            width: '100%'
          }}>
            <Grid container alignItems={'center'}
              justifyContent={'flex-start'}>
              <Grid item sx={{ marginTop: 1.5, width: '100%' }}>
                {
                  tabs.map((tab, index) => {
                    if (index !== selectedTab) {
                      return null
                    }
                    return (
                      tab
                    )
                  })
                }
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default MobileTabWrapper